// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBar_wrap__3wkZE","input":"SearchBar_input__Yw+zU","icon":"SearchBar_icon__YNEQF"};